import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CodeIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M14.24 3.03a1 1 0 0 1 .73 1.21l-4 16a1 1 0 1 1-1.94-.48l4-16a1 1 0 0 1 1.21-.73ZM6.71 7.29a1 1 0 0 1 0 1.42L3.4 12l3.3 3.3a1 1 0 1 1-1.42 1.4l-4-4a1 1 0 0 1 0-1.4l4-4a1 1 0 0 1 1.42 0Zm10.58 0a1 1 0 0 1 1.42 0l4 4a1 1 0 0 1 0 1.42l-4 4a1 1 0 0 1-1.42-1.42L20.6 12l-3.3-3.3a1 1 0 0 1 0-1.4Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default CodeIcon;
